class HeaderMenu {
  constructor(section) {
    this.section = section;
    this.initMegaMenu();
    this.initMobileMenu();
    this.initDrawerSubmenus();
    this.updateHeaderHeight();
    this.initResizeObserver();
  }

  updateHeaderHeight() {
    const header = this.section;
    if (header) {
      const headerHeight = header.offsetHeight;
      window.headerHeight = headerHeight;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      console.log('[Header] Header height updated:', headerHeight + 'px');
    }
  }

  initResizeObserver() {
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.updateHeaderHeight();
      }, 250);
    });
  }

  initMegaMenu() {
    const isTemplate3 = this.section.dataset.headerTemplate === '3';
    const menuToggles = this.section.querySelectorAll('[data-menu-toggle]');
    const allMegaMenus = this.section.querySelectorAll('.header-menu__mega-menu, .header-menu__mega-menu--t2');
    const container = this.section.querySelector('.header-menu__container');
    const bottomRow = isTemplate3
      ? this.section.querySelector('.header-menu__row--t2')
      : this.section.querySelector('.header-menu__bottom-row');
    const overlay = this.section.querySelector('.header-menu__overlay');

    menuToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        const menuId = toggle.dataset.menuToggle;
        const parentItem = toggle.closest('.header-menu__nav-item--has-dropdown');
        const megaMenu = this.section.querySelector(`.header-menu__mega-menu[data-menu-id="${menuId}"]`);
        const isActive = parentItem.classList.contains('is-active');

        // Check if another menu is already open (switching)
        const previouslyActive = this.section.querySelector('.header-menu__mega-menu.is-active');
        const isSwitching = previouslyActive && previouslyActive !== megaMenu && !isActive;

        // Close all other menus and mega menus
        this.section.querySelectorAll('.header-menu__nav-item--has-dropdown').forEach(item => {
          if (item !== parentItem) {
            item.classList.remove('is-active');
          }
        });

        if (isSwitching) {
          // Switching: content swaps instantly, wrapper height transitions smoothly
          allMegaMenus.forEach(menu => {
            if (menu !== megaMenu) {
              menu.style.transition = 'none';
              menu.classList.remove('is-active');
            }
          });

          parentItem.classList.add('is-active');
          toggle.setAttribute('aria-expanded', 'true');

          // Measure new menu height
          megaMenu.style.maxHeight = 'none';
          megaMenu.style.position = 'absolute';
          megaMenu.style.visibility = 'hidden';
          megaMenu.style.display = 'block';
          const newHeight = megaMenu.scrollHeight;
          megaMenu.style.maxHeight = '';
          megaMenu.style.position = '';
          megaMenu.style.visibility = '';
          megaMenu.style.display = '';

          if (bottomRow && container) {
            const bottomRowRect = bottomRow.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
            const bottomRowBottom = bottomRowRect.bottom - containerRect.top;
            const totalHeight = bottomRowBottom + newHeight + 18;
            const afterHeight = totalHeight - (containerRect.height - 30) + 18;
            const wrapperHeight = newHeight + 18;
            container.style.setProperty('--mega-menu-height', `${afterHeight}px`);
            container.style.setProperty('--mega-menu-content-height', `${newHeight}px`);
            container.style.setProperty('--wrapper-height', `${wrapperHeight}px`);
          }

          // Show new content instantly
          megaMenu.style.transition = 'none';
          megaMenu.classList.add('is-active');

          // Re-enable transitions on next frame
          requestAnimationFrame(() => {
            allMegaMenus.forEach(menu => {
              menu.style.transition = '';
            });
          });

        } else {
          allMegaMenus.forEach(menu => {
            if (menu !== megaMenu) {
              menu.classList.remove('is-active');
            }
          });

          // Toggle current menu
          if (isActive) {
            parentItem.classList.remove('is-active');
            if (megaMenu) megaMenu.classList.remove('is-active');
            toggle.setAttribute('aria-expanded', 'false');
            if (container) {
              container.style.setProperty('--mega-menu-height', '30px');
              container.style.setProperty('--mega-menu-content-height', '0px');
              container.style.setProperty('--wrapper-height', '0px');
            }
            // Hide overlay and restore body scroll
            if (overlay) overlay.classList.remove('is-active');
            document.body.classList.remove('menu-open');
          } else {
            parentItem.classList.add('is-active');
            toggle.setAttribute('aria-expanded', 'true');
            if (megaMenu) {
              // Show overlay and block body scroll
              if (overlay) overlay.classList.add('is-active');
              document.body.classList.add('menu-open');

              // Measure height
              megaMenu.style.maxHeight = 'none';
              megaMenu.style.position = 'absolute';
              megaMenu.style.visibility = 'hidden';
              megaMenu.style.display = 'block';
              const realHeight = megaMenu.scrollHeight;
              megaMenu.style.maxHeight = '';
              megaMenu.style.position = '';
              megaMenu.style.visibility = '';
              megaMenu.style.display = '';

              // Set CSS variables BEFORE adding is-active
              if (bottomRow && container) {
                const bottomRowRect = bottomRow.getBoundingClientRect();
                const containerRect = container.getBoundingClientRect();
                const bottomRowBottom = bottomRowRect.bottom - containerRect.top;
                const totalHeight = bottomRowBottom + realHeight + 18;
                const afterHeight = totalHeight - (containerRect.height - 30) + 18;
                const wrapperHeight = realHeight + 18;
                container.style.setProperty('--mega-menu-height', `${afterHeight}px`);
                container.style.setProperty('--mega-menu-content-height', `${realHeight}px`);
                container.style.setProperty('--wrapper-height', `${wrapperHeight}px`);
              }

              // Add is-active — CSS transitions on max-height kick in via the variables
              megaMenu.classList.add('is-active');
            }
          }
        }
      });
    });

    // Le panneau est dimensionné par des variables CSS figées à l'ouverture.
    // Quand la largeur change, les cartes du mega menu se réorganisent sur un
    // nombre de rangées différent : sans recalcul, la hauteur reste celle de
    // l'ancienne disposition et la dernière rangée est coupée. On reporte le
    // delta sur les variables plutôt que de refaire le calcul complet, qui a
    // besoin de la hauteur du container FERMÉ — indisponible menu ouvert.
    const syncActiveMegaMenuHeight = () => {
      if (!container) return;
      const active = this.section.querySelector(
        '.header-menu__mega-menu.is-active, .header-menu__mega-menu--t2.is-active'
      );
      if (!active) return;
      const realHeight = active.scrollHeight;
      const previous = parseFloat(container.style.getPropertyValue('--mega-menu-content-height'));
      if (!previous || Math.abs(realHeight - previous) < 1) return;
      const previousAfter = parseFloat(container.style.getPropertyValue('--mega-menu-height')) || 0;
      container.style.setProperty('--mega-menu-height', `${previousAfter + realHeight - previous}px`);
      container.style.setProperty('--mega-menu-content-height', `${realHeight}px`);
      container.style.setProperty('--wrapper-height', `${realHeight + 18}px`);
    };

    if (typeof ResizeObserver !== 'undefined') {
      const gridObserver = new ResizeObserver(() => syncActiveMegaMenuHeight());
      this.section
        .querySelectorAll('.header-menu__mega-cards-grid')
        .forEach(grid => gridObserver.observe(grid));
    }

    // Close menu when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.header-menu__bottom-row') && !e.target.closest('.header-menu__row--t2') && !e.target.closest('.header-menu__mobile-header') && !e.target.closest('.header-menu__mega-menu-wrapper')) {
        const hasActiveMegaMenu = this.section.querySelector('.header-menu__nav-item--has-dropdown.is-active');

        this.section.querySelectorAll('.header-menu__nav-item--has-dropdown').forEach(item => {
          item.classList.remove('is-active');
          const toggle = item.querySelector('[data-menu-toggle]');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        });
        allMegaMenus.forEach(menu => {
          menu.classList.remove('is-active');
        });
        if (container) {
          container.style.setProperty('--mega-menu-height', '30px');
          container.style.setProperty('--mega-menu-content-height', '0px');
          container.style.setProperty('--wrapper-height', '0px');
        }
        // Hide overlay and restore body scroll only if there was an active mega menu
        if (overlay) overlay.classList.remove('is-active');
        if (hasActiveMegaMenu) {
          document.body.classList.remove('menu-open');
        }
      }
    });

    // Close menu when clicking on overlay
    if (overlay) {
      overlay.addEventListener('click', () => {
        this.section.querySelectorAll('.header-menu__nav-item--has-dropdown').forEach(item => {
          item.classList.remove('is-active');
          const toggle = item.querySelector('[data-menu-toggle]');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        });
        allMegaMenus.forEach(menu => {
          menu.classList.remove('is-active');
        });
        if (container) {
          container.style.setProperty('--mega-menu-height', '30px');
          container.style.setProperty('--mega-menu-content-height', '0px');
          container.style.setProperty('--wrapper-height', '0px');
        }
        overlay.classList.remove('is-active');
        document.body.classList.remove('menu-open');
      });
    }
  }

  initMobileMenu() {
    const mobileToggle = this.section.querySelector('.header-menu__mobile-toggle');
    const drawer = this.section.querySelector('.header-menu__drawer');
    const drawerOverlay = this.section.querySelector('.header-menu__drawer-overlay');
    const drawerContent = this.section.querySelector('.header-menu__drawer-content');

    if (!mobileToggle || !drawer) return;

    const calculateDrawerPosition = () => {
      // Get mobile header position in viewport
      const mobileHeader = this.section.querySelector('.header-menu__mobile-header');
      if (!mobileHeader) return;

      const headerRect = mobileHeader.getBoundingClientRect();
      const headerBottom = headerRect.bottom;

      // Border radius of mobile header (16px as per CSS) + extra overlap
      const headerBorderRadius = 20;

      // Calculate position and available height from viewport
      const drawerTop = headerBottom - headerBorderRadius;
      const availableHeight = window.innerHeight - drawerTop;

      if (drawerContent) {
        drawerContent.style.top = `${drawerTop}px`;
        drawerContent.style.maxHeight = `${availableHeight}px`;
      }
    };

    const openDrawer = () => {
      calculateDrawerPosition();
      drawer.classList.add('is-active');
      mobileToggle.classList.add('is-active');
      document.body.classList.add('menu-open');
    };

    const closeDrawer = () => {
      drawer.classList.remove('is-active');
      mobileToggle.classList.remove('is-active');
      document.body.classList.remove('menu-open');
      if (drawerContent) {
        drawerContent.style.top = '0px';
      }
    };

    mobileToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      if (drawer.classList.contains('is-active')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    if (drawerOverlay) {
      drawerOverlay.addEventListener('click', closeDrawer);
    }

    // Refresh drawer position on scroll
    window.addEventListener('scroll', () => {
      if (drawer.classList.contains('is-active')) {
        calculateDrawerPosition();
      }
    });

    // Close drawer on window resize to desktop
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (window.innerWidth >= 990 && drawer.classList.contains('is-active')) {
          closeDrawer();
        } else if (window.innerWidth < 990 && drawer.classList.contains('is-active')) {
          calculateDrawerPosition();
        }
      }, 250);
    });
  }

  initDrawerSubmenus() {
    const drawerToggles = this.section.querySelectorAll('[data-drawer-toggle]');

    drawerToggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        const parentItem = toggle.closest('.header-menu__drawer-item--has-submenu');
        const isActive = parentItem.classList.contains('is-active');

        // Close all other submenus
        this.section.querySelectorAll('.header-menu__drawer-item--has-submenu').forEach(item => {
          if (item !== parentItem) {
            item.classList.remove('is-active');
            const otherToggle = item.querySelector('[data-drawer-toggle]');
            if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
          }
        });

        // Toggle current submenu
        if (isActive) {
          parentItem.classList.remove('is-active');
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          parentItem.classList.add('is-active');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderMenu);
} else {
  initHeaderMenu();
}

function initHeaderMenu() {
  const sections = document.querySelectorAll('[data-section-type="header"]');
  sections.forEach(section => {
    new HeaderMenu(section);
  });
}

// Shopify theme editor support
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.dataset.sectionType === 'header') {
      new HeaderMenu(event.target);
    }
  });
}
